var React = require("react");
var component;
var desc = {
	loadComponent: function(callback) {
		if(!component) {
			require.ensure([], function() {
				component = require("!!./../../node_modules/react-proxy-loader/index.js!./../../node_modules/babel-loader/index.js!./LoadingPage.jsx");
				if(callback) callback(component);
			}, "LoadingPage");
		} else if(callback) callback(component);
		return component;
	},
};
var mixinReactProxy = require("./../../node_modules/react-proxy-loader/mixinReactProxy.js");
mixinReactProxy(React, desc);
module.exports = React.createClass(desc);
module.exports.Mixin = desc;


//////////////////
// WEBPACK FOOTER
// ./~/react-proxy-loader?name=LoadingPage!./src/pages/LoadingPage.jsx
// module id = 1226
// module chunks = 0